export default __webpack_public_path__ + "static/media/ie.18f838a6.jpg";